import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';
import { useDispatch } from 'react-redux';

export default function useOtherCallbacks() {
  const dispatch = useDispatch();

  return {
    getIndex: () => dispatch(requests.thunks.getIndex()),
    getIcons: () => dispatch(requests.thunks.getIcons()),
    getParams: () => dispatch(requests.thunks.getParams()),
    setShowMessage: (showMessage) => dispatch(content.actions.setShowMessage(showMessage)),
    setIsSound: (isSound) => dispatch(content.actions.setIsSound(isSound)),
  };
}
